/* eslint-disable max-len */
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type LocalCustomerManagementModuleSpecsFragment } from '../../../../api/fragments/LocalCustomerManagementModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import { useAddKYCPresetDrawer } from './AddKYCPresetDrawer';

export type KYCPresetsEmptyListProps = {
    module: LocalCustomerManagementModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const KYCPresetsEmptyList = ({ module, permissions }: KYCPresetsEmptyListProps) => {
    const { t } = useTranslation('localCustomerModuleDetails');
    const addKYCPresetDrawer = useAddKYCPresetDrawer(module.id);
    const { hasUpdatePermission } = permissions;

    return (
        <>
            <NoItemResult
                extra={
                    hasUpdatePermission && (
                        <Button onClick={addKYCPresetDrawer.open} type="primary">
                            {t('localCustomerModuleDetails:emptyList.kycPresets.noData.action')}
                        </Button>
                    )
                }
                subTitle={t('localCustomerModuleDetails:emptyList.kycPresets.noData.message')}
            />
            {addKYCPresetDrawer.render()}
        </>
    );
};

export default KYCPresetsEmptyList;
